import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-067fec55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "engineer-status-container f1 fv hidden" }
const _hoisted_2 = {
  class: "fh-s-b",
  style: {"height":"9.33%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06 bold" }, "客服状态", -1))
const _hoisted_4 = {
  class: "f1 hidden",
  style: {"height":"calc(90.67% - 16px)","padding-top":"16px"}
}
const _hoisted_5 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menuItem = _resolveComponent("a-menuItem")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_VirtualColumnVue = _resolveComponent("VirtualColumnVue")!
  const _component_VirtualTableVue = _resolveComponent("VirtualTableVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_dropdown, { style: {"width":"200px"} }, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, { class: "menu" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setStatus(null)))
                  }, "全部")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setStatus('overflow')))
                  }, "忙碌")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setStatus('showBusy')))
                  }, "示忙")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setStatus('online')))
                  }, "在线")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setStatus('offline')))
                  }, "离线")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "fs12 color-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, _toDisplayString(_ctx.statusFilter(_ctx.statusRef)), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_VirtualTableVue, {
        data: _ctx.data,
        openVirtual: "",
        style: {"width":"100%","height":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VirtualColumnVue, {
            prop: "index",
            width: "40",
            label: "序号"
          }, {
            default: _withCtx(({ index }) => [
              _createTextVNode(_toDisplayString(index + 1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_VirtualColumnVue, {
            prop: "engineerName",
            width: "80",
            label: "姓名"
          }),
          _createVNode(_component_VirtualColumnVue, {
            prop: "serviceDeskName",
            width: "80",
            label: "客服组"
          }),
          _createVNode(_component_VirtualColumnVue, {
            prop: "chatCount",
            width: "80",
            label: "当前会话量"
          }),
          _createVNode(_component_VirtualColumnVue, {
            prop: "ticketCount",
            width: "80",
            label: "当前工单量"
          }),
          _createVNode(_component_VirtualColumnVue, {
            prop: "seatStatus",
            width: "60",
            label: "状态"
          }, {
            default: _withCtx(({ data }) => [
              _createElementVNode("div", {
                class: _normalizeClass(["fh-c-c tag", ['tag-' + data.seatStatus, _ctx.theme]])
              }, [
                _createElementVNode("span", {
                  title: _ctx.statusFilter(data.seatStatus)
                }, _toDisplayString(_ctx.statusFilter(data.seatStatus)), 9, _hoisted_5)
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ]))
}